module.exports = __webpack_public_path__ + "img/9788936456634.0322bf87.jpg";